<template>
  <div class="container content-p">
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="studentData === undefined">
      <h4 class="alert-heading">Error fetching student data</h4>
      <div class="alert-body">
        No student found with this student id. Check
        <b-link class="alert-link" :to="{ name: 'apps-roster-student-list-pending' }"> Student List </b-link>
        for other students.
      </div>
    </b-alert>

    <b-tabs v-if="studentData" lazy v-model="tabIndex">
      <!-- Tab: Information -->
      <b-tab>
        <template #title>
          <feather-icon icon="UserIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Student</span>
        </template>
        <student-edit-tab-information :student-data.sync="studentData" />
      </b-tab>

      <!-- Tab: Social Links  -->
      <b-tab>
        <template #title>
          <feather-icon icon="InstagramIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Social Links</span>
        </template>
        <student-edit-tab-social-links :student-data.sync="studentData" />
      </b-tab>

      <!-- Tab: Information -->
      <!-- <b-tab v-if="false">
        <template #title>
          <feather-icon icon="PaperclipIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Attributes</span>
        </template>
        <student-edit-tab-attributes :student-data.sync="studentData" />
      </b-tab> -->

      <!-- Tab: Emails -->
      <b-tab>
        <template #title>
          <feather-icon icon="MailIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Email Addresses</span>
        </template>
        <student-edit-tab-emails :student-data.sync="studentData" />
      </b-tab>

      <!-- Tab: Phone Numbers -->
      <b-tab>
        <template #title>
          <feather-icon icon="PhoneIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Phone Numbers</span>
        </template>
        <student-edit-tab-phone-numbers :student-data.sync="studentData" />
      </b-tab>

      <!-- Tab: Addresses -->
      <b-tab>
        <template #title>
          <feather-icon icon="HomeIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Addresses</span>
        </template>
        <student-edit-tab-addresses :student-data.sync="studentData" />
      </b-tab>

      <!-- Tab: MyIP Abilities -->
      <b-tab>
        <template #title>
          <feather-icon icon="ShieldIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">MyIP Abilities</span>
        </template>
        <student-edit-tab-abilities :student-data.sync="studentData" />
      </b-tab>

      <!-- Tab: Notes -->
      <!-- <b-tab>
        <template #title>
          <feather-icon icon="Edit3Icon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Notes</span>
        </template>
        <student-edit-tab-notes :student-data.sync="studentData" />
      </b-tab> -->

      <!-- Tab: Secret -->
      <b-tab v-if="$can('student.profile.secret')">
        <template #title>
          <feather-icon icon="LockIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Secret</span>
        </template>
        <student-edit-tab-secret :student-data.sync="studentData" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink } from 'bootstrap-vue';
import { ref, onUnmounted } from '@vue/composition-api';
import router from '@/router';
import store from '@/store';
import studentStoreModule from '../../../../store/student/studentStoreModule';
import StudentEditTabInformation from './tabs/StudentEditTabInformation.vue';
import StudentEditTabAttributes from './tabs/StudentEditTabAttributes';
import StudentEditTabAddresses from './tabs/StudentEditTabAddresses';
import StudentEditTabEmails from './tabs/StudentEditTabEmails';
import StudentEditTabPhoneNumbers from './tabs/StudentEditTabPhoneNumbers';
import StudentEditTabSocialLinks from './tabs/StudentEditTabSocialLinks';
import StudentEditTabAbilities from '@/views/apps/student/students-edit/tabs/StudentEditTabAbilities';
import StudentEditTabSecret from './tabs/StudentEditTabSecret';

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    StudentEditTabAttributes,
    StudentEditTabInformation,
    StudentEditTabAddresses,
    StudentEditTabEmails,
    StudentEditTabPhoneNumbers,
    StudentEditTabSocialLinks,
    StudentEditTabAbilities,
    StudentEditTabSecret,
  },
  data: () => {
    return {
      tabIndex: 0,
    };
  },
  mounted() {
    const { tab } = this.$route.query;

    if (tab === 'social') {
      this.tabIndex = 1;
    } else if (tab === 'notes') {
      this.tabIndex = 5;
    }
  },
  setup() {
    const studentData = ref(null);
    const profileData = ref(null);

    store
      .dispatch('studentStoreModule/fetchStudent', { id: router.currentRoute.params.id })
      .then((response) => {
        studentData.value = response.data;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          studentData.value = undefined;
        }
      });

    return {
      studentData,
    };
  },
};
</script>

<style></style>
